import { useCasesBoardActiveCountQuery } from '@/queries/case';

export const ActiveCases = () => {
  const { data: activeCasesCount } = useCasesBoardActiveCountQuery();

  if (activeCasesCount === undefined) return null;

  return (
    <div className="mr-2">
      <span className="text-m-r text-base-5">Total Active Cases: {activeCasesCount}</span>
    </div>
  );
};
